import { render } from "./LimitExceeded.vue?vue&type=template&id=30bad03a&scoped=true"
import script from "./LimitExceeded.vue?vue&type=script&lang=js"
export * from "./LimitExceeded.vue?vue&type=script&lang=js"

import "./LimitExceeded.vue?vue&type=style&index=0&id=30bad03a&scoped=true&lang=css"

import exportComponent from "/tmp/build_719f45e5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30bad03a"]])

export default __exports__